export default __webpack_public_path__ + "static/media/ALEJANDRO LANUSSE.f96c53e9.jpg";